import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  Input,
  FormControl,
  FormLabel,
} from "@chakra-ui/react";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
interface AddUserModalProps {
  isOpen: boolean;
  onClose: () => void;
  onAddUser: (user: { email: string; name: string }) => void; // callback
}

const AddUserModal: React.FC<AddUserModalProps> = ({
  isOpen,
  onClose,
  onAddUser,
}) => {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");

  const handleAddUser = () => {
    onAddUser({ email, name }); // call parent function

    onClose(); // close modal after adding
    setEmail("");
    setName(""); // reset fields
  };
  const { t } = useTranslation("common");

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent borderRadius="12px" bg="white">
        <ModalHeader>{t("admin.addNewUser")}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <FormControl mb={4}>
            <FormLabel>{t("admin.email")}</FormLabel>
            <Input
              placeholder={t("admin.enterEmail")}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </FormControl>
          <FormControl>
            <FormLabel>{t("admin.name")}</FormLabel>
            <Input
              placeholder={t("admin.enterName")}
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </FormControl>
        </ModalBody>

        <ModalFooter>
          <Button variant="outline" mr={3} onClick={onClose}>
            {t("admin.cancel")}
          </Button>
          <Button bg="#40599B" onClick={handleAddUser}>
            {t("admin.addUser")}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default AddUserModal;
